import React from 'react';
import { FaStop } from 'react-icons/fa';
import { useChatContext } from '../context/ChatContext';
import { useWebSocket } from '../hooks/useWebSocket';

const MessageInput = () => {
  const { input, dispatch } = useChatContext();
  const { sendMessage, stopStream, isConnected, isStreaming } = useWebSocket();

  const handleSend = () => {
    sendMessage(input);
    dispatch({ type: 'SET_INPUT', payload: '' });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <div className="message-form" role="form" aria-label="Send message">
      <label htmlFor="message-input" className="sr-only">Type your message</label>
      <input
        id="message-input"
        className="message-input"
        type="text"
        value={input}
        placeholder={isConnected ? "Ask a question..." : "Connecting..."}
        onChange={e => dispatch({ type: 'SET_INPUT', payload: e.target.value })}
        onKeyDown={handleKeyDown}
        disabled={!isConnected || isStreaming}
        aria-describedby={isStreaming ? "streaming-status" : undefined}
      />
      {isStreaming && <div id="streaming-status" className="sr-only">Message is being processed</div>}
      {isStreaming ? (
        <button className="send-button stop-button" onClick={stopStream} title="Stop">
          <FaStop />
        </button>
      ) : (
        <button className="send-button" onClick={handleSend} disabled={!isConnected}>
          Send
        </button>
      )}
    </div>
  );
};

export default MessageInput;